// Copyright (c) 2017 Deere & Company

import {routerActions} from 'react-router-redux';
import {updateRegistration} from '../../product/product-registration/action-creators/registration';

export const customerPanelRegistration = customer =>

    dispatch => {

        updateRegistration('customer', customer)(dispatch);
        dispatch(routerActions.push('/products/register-product'));

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/customer-panel-registration.js